import { type NavigateOptions, type To } from "react-router-dom";

export type NavigateEventDetail = {
  options: NavigateOptions | undefined;
  to: To | number;
};
export class NavigationEvent extends Event {
  public static NAME = "NavigateCustom";

  public static dispatch(detail: NavigateEventDetail, cancelable: boolean) {
    let element = document.querySelector("_nav_");
    if (!element) {
      element = document.createElement("div");
      element.id = "_nav_";
      document.body.append(element);
    }

    element.dispatchEvent(
      new CustomEvent<NavigateEventDetail>(NavigationEvent.NAME, { cancelable, bubbles: true, detail })
    );
  }
}
